import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
Vue.use(VueRouter)
Vue.use(Router)
const Home = () =>
    import ( /* webpackChunkname:"Home" */ '@vie/Home');

const Login = () =>
    import ( /* webpackChunkname:"Login" */ '@vie/Login');
const homePage = () =>
    import ( /* webpackChunkname:"homePage" */ '@vie/homePage/homePage');
const his = () =>
    import ( /* webpackChunkname:"his" */ '@vie/homePage/his');
const hisimfo = () =>
    import ( /* webpackChunkname:"hisimfo" */ '@vie/homePage/hisimfo');
const rightimfo = () =>
    import ( /* webpackChunkname:"rightimfo" */ '@vie/homePage/rightimfo');
const mypaymentimfo = () =>
    import ( /* webpackChunkname:"mypaymentimfo" */ '@vie/homePage/mypaymentimfo');
const empty = () =>
    import ( /* webpackChunkname:"empty" */ '@vie/homePage/empty');

const routes = [{
        path: '/',
        redirect: '/home',
    },
    //登录页面
    {
        path: '/login',
        name: 'Login',
        explain: '登录页面',
        component: Login
    },

    // 主页
    {
        path: '/home',
        name: 'Home',
        explain: '主页面',
        component: Home,
        redirect: '/home/homePage',
        children: [{
            path: 'homePage',
            name: 'homePage',
            explain: '主页页面',
            component: homePage
        }]
    },
    //缴费记录

    {
        path: '/his',
        name: 'his',
        explain: '缴费记录',
        component: his
    },
    //缴费详情

    {
        path: '/hisimfo',
        name: 'hisimfo',
        explain: '缴费详情',
        component: hisimfo
    },
    //教师权限

    {
        path: '/rightimfo',
        name: 'rightimfo',
        explain: '教师权限',
        component: rightimfo
    },
    //缴费详情及提交订单页

    {
        path: '/mypaymentimfo',
        name: 'mypaymentimfo',
        explain: '缴费详情及提交订单页',
        component: mypaymentimfo
    },
    //错误页
    {
        path: '/empty',
        name: 'empty',
        explain: '错误页',
        component: empty
    },

]



const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// router.beforeEach((to, from, next) => {
//     // to 将要访问的路径
//     // from 代表从哪个路径跳转而来
//     // next 是一个函数，表示放行
//     //     next()  放行    next('/login')  强制跳转
//     if (to.path === '/login') return next()
//         // 获取token
//     const tokenStr = JSON.parse(localStorage.getItem('token'))
//     if (!tokenStr) return next('/login')
//     next()
// })


export default router